module.exports = __webpack_public_path__ + "static/media/checked2.7dad59db.svg";